import { Box, Chip, Typography } from "@mui/material";
import SoundCloudWidgets from "../../components/SoundCloudWidgets";
import YouTubeWidgets from "../../components/YouTubeWidgets";
import { useParams } from "react-router-dom";
import { useArtist } from "../../hooks/useArtist";
import PageLoader from "../../components/PageLoader";
import facebook from "../../assets/facebook.svg";
import instagram from "../../assets/instagram.svg";
import soundcloud from "../../assets/soundcloud.svg";
import { sanitizeHtml } from "../../utils/safeHtml";
import styles from "./styles";

const SOCIAL_LINKS = [
  { icon: facebook, key: "facebook", label: "Facebook" },
  { icon: instagram, key: "instagram", label: "Instagram" },
  { icon: soundcloud, key: "soundCloud", label: "SoundCloud" },
];

const ArtistPage = () => {
  const { id } = useParams();
  const { data: artist, isLoading, error } = useArtist(id);

  return (
    <PageLoader isLoading={isLoading} error={error} errorMessage="Failed to load artist">
      <Box sx={styles.pageWrapperSx}>

        <Box component="img" src={artist?.imageURL} alt={artist?.stageName} sx={styles.imageSx} />

        <Typography variant="h4" sx={styles.titleSx}>
          {artist?.stageName}
        </Typography>
        <Typography sx={styles.nameSx}>
          {artist?.name}
        </Typography>

        {/* Genres */}
        {!!artist?.genres?.length && (
          <Box sx={styles.genresRowSx}>
            {artist.genres.map((genre) => (
              <Chip key={genre} label={genre} variant="filled" color="primary" />
            ))}
          </Box>
        )}

        {/* Social links — external URLs must use <a>, not react-router <Link> */}
        <Box sx={styles.socialRowSx}>
          {SOCIAL_LINKS.map(({ icon, key, label }) =>
            artist?.[key] ? (
              <a key={key} href={artist[key]} target="_blank" rel="noopener noreferrer">
                <Box component="img" src={icon} alt={label} sx={styles.socialIconSx} />
              </a>
            ) : null
          )}
        </Box>

        {/* Description — sanitized HTML from rich text editor */}
        {artist?.description && (
          <Box
            sx={styles.descriptionSx}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(artist.description) }}
          />
        )}

        <Box sx={styles.clearSx} />

        <SoundCloudWidgets recordings={artist?.soundcloudLinks || []} />
        <YouTubeWidgets youtubeLinks={artist?.youtubeLinks || []} />
      </Box>
    </PageLoader>
  );
};

export default ArtistPage;
